import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUploadUrl } from '../utils/uploadUrl';
import './TasksOverviewBanner.css';

function TasksOverviewBanner({ imageUrl, activeCount, upcomingCount, calendarMode }) {
  const { t } = useTranslation(['tasks']);
  const resolvedUrl = imageUrl ? getUploadUrl(imageUrl) : null;

  return (
    <section
      className={`tasks-overview-banner${resolvedUrl ? ' tasks-overview-banner--has-image' : ''}`}
      style={resolvedUrl ? { '--tasks-overview-image': `url(${resolvedUrl})` } : undefined}
      aria-label={t('tasks:todaysOverview')}
    >
      <div className="tasks-overview-banner-overlay" />
      <div className="tasks-overview-banner-content">
        <h2 className="tasks-overview-banner-title">{t('tasks:todaysOverview')}</h2>
        <p className="tasks-overview-banner-summary">
          {calendarMode
            ? t('tasks:overviewCalendarHint')
            : t('tasks:overviewSummary', {
                active: activeCount,
                upcoming: upcomingCount
              })}
        </p>
      </div>
    </section>
  );
}

export default TasksOverviewBanner;
